import { PmNodeType } from './../../../_shared/pm-node-types';

import type { IEditorQuery, ITreeNodeQuery, QueryItem } from '../../types';

const NAME = 'isListItem';
const isListItem: QueryItem =
  ({ editorQuery }: { editorQuery: IEditorQuery }) =>
  () => {
    const { doc } = editorQuery.selection();
    let hasDescendantListItem = false;

    doc.descendants((node: ITreeNodeQuery) => {
      if (node.type() === PmNodeType.LIST_ITEM) {
        hasDescendantListItem = true;
        return false;
      }
      return true;
    });

    return hasDescendantListItem;
  };

export default { NAME, query: isListItem };
